const POST_LOGIN_REDIRECT_KEY = "leadstatsPostLoginRedirect";
const LEADSTATS_MARKETING_LOGIN_PATH = "/marketing-automation-login";

const AUTH_PATHS = new Set([
  "/login",
  "/signup",
  "/reset-password",
  "/auth/sso-callback",
]);

export const sanitizePostLoginRedirect = (
  candidate: string | null | undefined
): string | null => {
  if (!candidate || typeof window === "undefined") return null;

  try {
    const url = new URL(candidate, window.location.origin);
    if (url.origin !== window.location.origin || AUTH_PATHS.has(url.pathname)) {
      return null;
    }

    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
};

export const rememberPostLoginRedirect = (candidate: string): void => {
  const redirect = sanitizePostLoginRedirect(candidate);
  if (!redirect) return;

  try {
    window.sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, redirect);
  } catch {
    // Some privacy modes disable storage. Login still works without a return
    // destination, so this should never block authentication.
  }
};

export const consumePostLoginRedirect = (): string | null => {
  try {
    const candidate = window.sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
    window.sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
    return sanitizePostLoginRedirect(candidate);
  } catch {
    return null;
  }
};

export const buildLeadStatsMarketingLoginUrl = (
  configuredLoginUrl: string
): string => {
  try {
    const url = new URL(configuredLoginUrl);
    url.pathname = LEADSTATS_MARKETING_LOGIN_PATH;
    url.search = "";
    url.hash = "";
    return url.toString();
  } catch {
    return configuredLoginUrl;
  }
};
